module.exports = __webpack_public_path__ + "static/media/home_page.7b24edd3.jpg";